import React from 'react';
import styled from 'styled-components';

type GisGuideSpecificationsProps = {
  className?: string;
};

const Col = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const H1 = styled.h1`
  margin: 0 0 14px;
  font-size: 44px;
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: -0.02em;

  @media (max-width: 767px) {
    font-size: 34px;
  }
`;

const P = styled.p`
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
  color: rgba(11, 18, 32, 0.86);
`;

const Strong = styled.strong`
  font-weight: 800;
`;

const TemplateList = styled.div`
  margin: 14px 0 6px;
  display: grid;
  gap: 10px;
`;

const TemplateItem = styled.h5`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 800;
  color: rgba(11, 18, 32, 0.92);
`;

const Spacer = styled.div`
  height: 28px;
`;

const EmailLink = styled.a`
  color: #b1002a;
  font-weight: 800;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;

  &:hover {
    opacity: 0.85;
  }
`;

export const GisGuideSpecifications: React.FC<GisGuideSpecificationsProps> = ({ className }) => (
        <Col className={className}>
            <H1>Guide Specifications</H1>
            <P>
                These templates are intended to be used with the AWMAC standards manual (current edition at
                date of tender) – hereinafter referenced as NAAWS (North American Architectural Woodwork
                Standards).
            </P>
            <P>
                <Strong>
                    It is strongly recommended that you read the appropriate Sections of NAAWS before using
                    any guide spec. Many of the items you would ordinarily specify are governed by your choice
                    of Grade.
                </Strong>
            </P>
            <P>
                To receive the following templates in Word format, please send a request to{' '}
                <EmailLink href="mailto:info.bc@awmac.com">info.bc@awmac.com</EmailLink>.
            </P>
            <TemplateList aria-label="Templates list">
                <TemplateItem>Section 06 40 00 – Architectural Wood Casework</TemplateItem>
                <TemplateItem>Section 06 42 00 – Wood Paneling</TemplateItem>
                <TemplateItem>Section 06 46 00 – Wood Trim</TemplateItem>
                <TemplateItem>Section 08 14 00 – Wood Doors</TemplateItem>
            </TemplateList>
            <Spacer aria-hidden="true" />
        </Col>
);
